import { AlertBarContext, AlertBarProviderContext } from 'components/no-ui/context/alertbarprovider'
import { useContext } from 'react'

export const useAlert = (): AlertBarProviderContext => useContext<AlertBarProviderContext>(AlertBarContext)
